import React, { useState } from 'react';
import images from '../../themes/appImage'
import appconstants from "../../themes/appconstant";
import * as Yup from 'yup';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import ButtonLayout from "../../common/layoutButton";
import { forgotPasswordLoad } from '../../redux/slices/auth.slice'



const ForgotPassword = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch();

    const arrowClick = () => {
        navigate('/login')
    }

    const initialValues = {
        email: '',
    };

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .email('Please enter valid email address.')
            .required('Please enter email address.'),
    });

    const forgotPassword = (values) => {
        dispatch(forgotPasswordLoad(values));
    };

    return (
        <div className="w-[100vw] h-[100vh] bg-background flex flex-col items-center justify-between  ">
            <div className='max-w-[424px] max-h-[455px]  flex items-center flex-col mt-5   '>
                <img className=" mb-5 " src={images.appLogo} alt="metafit-logo" />
                <div className='w-full bg-white border shadow-metafit-shadow rounded-lg p-5 md:p-2 sm:w-[100vw] '>
                    <div className='flex gap-x-32'>
                        <div onClick={arrowClick} className='cursor-pointer'> <img src={images.backArrow} alt="arrow-left" /></div>

                        <div className='w-20 h-20 bg-royalPurple rounded-full flex justify-center items-center'>
                            <img src={images.lock} alt="password" />
                        </div>

                    </div>
                    <div className='text-2xl font-semibold text-dark text-center mt-8 mb-1'>{appconstants.forgotYourPassword}</div>
                    <div className="text-sm text-center text-gray60 mb-5">{appconstants.forgotText}</div>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={forgotPassword}
                    >
                        {({ isSubmitting, errors }) => (
                            <Form className="max-w-sm mx-auto">
                                <div className="mb-5">
                                    <label htmlFor="email" className="block mb-2 text-sm font-[400] text-dark">{appconstants.Email}</label>
                                    <Field
                                        type="email"
                                        name="email"
                                        className="border border-gray-300 text-dark text-sm rounded-lg  block w-full py-[12px] px-[14px] h-[48px] focus:outline-none focus:border-gray-300"
                                        placeholder="Enter your email"
                                    />
                                    <ErrorMessage name="email" component="div" className="text-red-500 text-xs font-normal" />
                                </div>

                                <div className="mb-5">
                                    <ButtonLayout text={appconstants.submit} className="ml-1/3" type="submit" />
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
            <div className=" text-sm text-light mb-3 ">{appconstants.metafitRights}</div>
        </div>
    );
}

export default ForgotPassword;
